export default "__VITE_ASSET__DukY54tI__"